import React from 'react';
import Widget from './Widget';
import PostItem from './PostItem';

const WidgetRecentPosts = () => (
  <Widget>
    <h3 className="widget-title">Recent Posts</h3>
    <ul className="widget-content">
      <li>
        <PostItem
          postTitle="Django Middleware: An overview of middleware"
          postDate="August 17, 2016"
          postUrl="/blog/django-middleware-overview"
        />
      </li>
      <li>
        <PostItem
          postTitle="Django How-To: Using the null and blank field options"
          postDate="March 25, 2016"
          postUrl="/blog/django-howto-null-blank-field-options"
        />
      </li>
      <li>
        <PostItem
          postTitle="Django project layout alternatives"
          postDate="March 8, 2016"
          postUrl="/blog/django-project-layout-alternatives"
        />
      </li>
    </ul>
  </Widget>
);

export default WidgetRecentPosts;



// WEBPACK FOOTER //
// ./src/components/WidgetRecentPosts.js